import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { MapPin, BellOff } from "lucide-react";

// V1 « app ouverte » : position demandée uniquement quand SanitDocs est actif, jamais stockée ; alerte si un établissement proche a des documents.
export function ProximityWatcher({ orgEnabled, userEnabled }) {
  const nav = useNavigate();
  const [enabled, setEnabled] = useState(userEnabled !== false);
  const alerted = useRef(new Set());
  useEffect(() => {
    if (!orgEnabled || !enabled || !navigator.geolocation) return;
    let last = 0;
    const id = navigator.geolocation.watchPosition(async (pos) => {
      if (Date.now() - last < 60_000) return; last = Date.now();
      try {
        const { data } = await api.get("/proximity/nearby", { params: { lat: pos.coords.latitude, lng: pos.coords.longitude } });
        (data.nearby || []).forEach((g) => {
          if (alerted.current.has(g.establishment_id)) return;
          alerted.current.add(g.establishment_id);
          toast(`Vous êtes près de ${g.establishment_name} — ${g.count} document${g.count > 1 ? "s" : ""} à récupérer`, {
            icon: <MapPin className="w-4 h-4 text-accent-600" />, duration: 12000, action: { label: "Voir", onClick: () => nav(`/driver/etablissement/${g.establishment_id}`) } });
        });
      } catch (_) {}
    }, () => {}, { enableHighAccuracy: false, maximumAge: 60_000, timeout: 15_000 });
    return () => navigator.geolocation.clearWatch(id);
  }, [orgEnabled, enabled]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!orgEnabled) return null;
  const toggle = async () => { const v = !enabled; setEnabled(v); try { await api.put("/push/proximity-preference", { enabled: v }); } catch (_) {} toast(v ? "Alertes de proximité activées" : "Alertes de proximité désactivées"); };
  return (
    <button type="button" data-testid="proximity-toggle" onClick={toggle} className={`inline-flex items-center gap-1.5 text-xs font-bold px-3 h-9 rounded-full border ${enabled ? "bg-accent-50 text-accent-800 border-accent-200" : "bg-slate-100 text-slate-500 border-slate-200"}`}>
      {enabled ? <MapPin className="w-3.5 h-3.5" /> : <BellOff className="w-3.5 h-3.5" />}Proximité {enabled ? "activée" : "désactivée"}
    </button>
  );
}
